import {SignStatus} from "../grantApplication/generatePSASigningLinkRequest";

export interface GenerateFWASigningLinkRequest {
  assignmentId: string;
  redirectUrl: string;
}
export interface GenerateVerifiedSigningLinkResponse{
  signingLink: string;
}
export interface VerifiedSignedStatusResponse {
  //0 null, 1 = signed, 2 = reject
  signedStatus: SignStatus
}
